import { LogoDefinition } from 'Brand/types';

export const brandIconAvatar: LogoDefinition = {
  id: 'brandIconAvatar',
  width: 32,
  height: 32,
  svgContent: [
    {
      type: 'path',
      fill: '#005FEC',
      data: 'M32.0137 -0.00683594H0.0136719V31.9932H32.0137V-0.00683594Z',
    },
    {
      type: 'path',
      fill: '#FFB800',
      data: 'M16.1219 13.8396C16.8125 13.8397 17.4875 13.635 18.0617 13.2514C18.6359 12.8678 19.0834 12.3225 19.3477 11.6846C19.612 11.0466 19.6812 10.3446 19.5465 9.66732C19.4118 8.99005 19.0793 8.36793 18.5911 7.87962C18.1028 7.39132 17.4807 7.05878 16.8034 6.92404C16.1262 6.7893 15.4242 6.85843 14.7862 7.12267C14.1482 7.38692 13.6029 7.83441 13.2193 8.40857C12.8356 8.98272 12.6309 9.65775 12.6309 10.3483C12.6309 11.2742 12.9987 12.1622 13.6534 12.817C14.3081 13.4717 15.196 13.8396 16.1219 13.8396Z',
    },
    {
      type: 'path',
      fill: 'white',
      data: 'M21.9586 14.6353H18.4564L16.1327 17.7437L13.7982 14.6353H10.2852L14.3766 20.0685L10.2852 25.5234H13.7982L16.1327 22.403L18.4564 25.5234H21.9586L17.8783 20.0685L21.9586 14.6353Z',
    },
  ],
};
